import { defineRecipe } from '@chakra-ui/react';

export const spinnerRecipe = defineRecipe({
  base: {
    color: 'marleyRed.500',
  },
});

export default spinnerRecipe;
